import React from 'react'
import ExportEventMenuItemBase from './ExportEventMenuItemBase'
import {useEvent} from 'Event/EventProvider'
import {useOrganization} from 'organization/OrganizationProvider'
import {api} from 'lib/url'
import {useGet} from 'lib/requests'

export default function ExportEventRoomAssignmentsMenuItem(props: {
  setError: (error: string | null) => void
  setSuccess: (success: string | null) => void
}) {
  const {
    exportRoomAssignments,
    processing,
    errorMessage,
    successMessage,
  } = useExportEventRoomAssignments()

  return (
    <ExportEventMenuItemBase
      ref={null}
      label="Export Room Assignments"
      ariaLabel="export event room assignments"
      onExport={exportRoomAssignments}
      processing={processing}
      errorMessage={errorMessage}
      successMessage={successMessage}
      setError={props.setError}
      setSuccess={props.setSuccess}
    />
  )
}

function useExportEventRoomAssignments() {
  const {event} = useEvent()
  const url = api(`/events/${event.id}/room_assignments/export`)
  const {client} = useOrganization()

  const {
    send: exportRoomAssignments,
    processing,
    errorMessage,
    successMessage,
  } = useGet(client, url)

  return {
    exportRoomAssignments,
    processing,
    errorMessage,
    successMessage,
  }
}
